// @ts-nocheck
/**
 * ツインキーシステム - 属性×カテゴリグループ別パッシブ
 *
 * 168種のパッシブ（7属性 × 6グループ × 4パッシブ）
 * 仕様書: twin_key_generic_skills_passives_v1.md
 */

import { CATEGORY_GROUPS } from '../categoryMapping';

// ========================================
// パッシブ効果タイプ定義
// ========================================

export const PASSIVE_EFFECT_TYPES = {
  // ステータス修正
  ATK_PERCENT: 'atk_percent',           // 攻撃力%増加
  HP_PERCENT: 'hp_percent',             // HP%増加
  DEF_PERCENT: 'def_percent',           // 防御力%増加（被ダメ軽減）
  SPD_FLAT: 'spd_flat',                 // 速度固定値増加
  CRIT_RATE: 'crit_rate',               // クリティカル率増加
  EVASION_RATE: 'evasion_rate',         // 回避率増加

  // 条件付き効果
  CONDITIONAL_ATK: 'conditional_atk',   // 条件付き攻撃力増加
  CONDITIONAL_DEF: 'conditional_def',   // 条件付き被ダメ軽減
  CONDITIONAL_DMG: 'conditional_dmg',   // 条件付きダメージ増加

  // ダメージ修正
  DAMAGE_BONUS: 'damage_bonus',         // 与ダメージ増加
  DAMAGE_REDUCE: 'damage_reduce',       // 被ダメージ軽減
  ATTRIBUTE_DAMAGE: 'attribute_damage', // 特定属性へのダメージ増加
  STATUS_DAMAGE: 'status_damage',       // 状態異常対象へのダメージ増加

  // 回復系
  HEAL_BOOST: 'heal_boost',             // 回復効果増加
  HEAL_RECEIVED: 'heal_received',       // 受ける回復増加
  REGEN: 'regen',                       // ターン終了時回復
  LIFESTEAL: 'lifesteal',               // 与ダメ吸収

  // 発動系
  ON_ATTACK: 'on_attack',               // 攻撃時発動
  ON_HIT: 'on_hit',                     // 被弾時発動
  ON_KILL: 'on_kill',                   // 撃破時発動
  ON_TURN_END: 'on_turn_end',           // ターン終了時発動
  ON_BATTLE_START: 'on_battle_start',   // 戦闘開始時発動
  ON_FIRST_ATTACK: 'on_first_attack',   // 先制攻撃時発動

  // 特殊
  STATUS_INFLICT: 'status_inflict',     // 状態異常付与
  STATUS_IMMUNITY: 'status_immunity',   // 状態異常無効
  COUNTER: 'counter',                   // 反撃
  ALLY_BUFF: 'ally_buff',               // 味方へのバフ
};

// ========================================
// パッシブトリガー条件
// ========================================

export const PASSIVE_CONDITIONS = {
  ALWAYS: 'always',                     // 常時発動
  HP_ABOVE: 'hp_above',                 // HP一定以上
  HP_BELOW: 'hp_below',                 // HP一定以下
  FIRST_ATTACK: 'first_attack',         // 先制攻撃時
  TARGET_STATUS: 'target_status',       // 対象が状態異常
  TARGET_ATTRIBUTE: 'target_attribute', // 対象が特定属性
  TARGET_HP_BELOW: 'target_hp_below',   // 対象HPが一定以下
  ON_HEAL: 'on_heal',                   // 回復発動時
  SAME_ENEMY_HIT: 'same_enemy_hit',     // 同じ敵からの連続被弾
};

// ========================================
// 炎属性パッシブ（24種）
// ========================================

export const FIRE_PASSIVES = {
  // 炎×アタッカー（ドラゴン、蛮族、デーモン）
  [CATEGORY_GROUPS.ATTACKER]: [
    {
      id: 'fire_attacker_1',
      name: '炎の猛攻',
      description: '攻撃力+12%',
      slot: 1,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 12 }],
    },
    {
      id: 'fire_attacker_2',
      name: '灼熱の闘志',
      description: 'HP80%以上で攻撃力+10%追加',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.CONDITIONAL_ATK, value: 10, condition: PASSIVE_CONDITIONS.HP_ABOVE, threshold: 80 }],
    },
    {
      id: 'fire_attacker_3',
      name: '炎上追撃',
      description: '火傷状態の敵へのダメージ+20%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.STATUS_DAMAGE, status: 'burn', value: 20 }],
    },
    {
      id: 'fire_attacker_ult',
      name: '火傷爆発',
      description: '火傷状態の敵へのダメージ+40%',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A7',
      effects: [{ type: PASSIVE_EFFECT_TYPES.STATUS_DAMAGE, status: 'burn', value: 40 }],
    },
  ],

  // 炎×タンク（ゴーレム、ガーディアン、マシン）
  [CATEGORY_GROUPS.TANK]: [
    {
      id: 'fire_tank_1',
      name: '灼熱の鎧',
      description: '被ダメージ-8%',
      slot: 1,
      effects: [{ type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 8 }],
    },
    {
      id: 'fire_tank_2',
      name: '溶岩の体躯',
      description: '被弾時15%で攻撃者に火傷付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HIT, chance: 15, effect: { type: 'status', status: 'burn' } }],
    },
    {
      id: 'fire_tank_3',
      name: '炎の反撃',
      description: '被弾時、攻撃力×20%で反撃',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.COUNTER, multiplier: 0.2 }],
    },
    {
      id: 'fire_tank_ult',
      name: 'カウンター',
      description: '被弾時100%で反撃',
      slot: 4,
      isUltimate: true,
      ultimateId: 'X4',
      effects: [{ type: PASSIVE_EFFECT_TYPES.COUNTER, multiplier: 1.0, chance: 100 }],
    },
  ],

  // 炎×スピード（鳥系、インセクト）
  [CATEGORY_GROUPS.SPEED]: [
    {
      id: 'fire_speed_1',
      name: '閃炎',
      description: '速度+10、攻撃力+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 5 },
      ],
    },
    {
      id: 'fire_speed_2',
      name: '疾風の炎',
      description: '先制攻撃時ダメージ+15%',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.CONDITIONAL_DMG, value: 15, condition: PASSIVE_CONDITIONS.FIRST_ATTACK }],
    },
    {
      id: 'fire_speed_3',
      name: '燃え盛る翼',
      description: '攻撃時20%で火傷付与',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 20, effect: { type: 'status', status: 'burn' } }],
    },
    {
      id: 'fire_speed_ult',
      name: '連撃',
      description: '通常攻撃が2回になる',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A6',
      effects: [{ type: 'double_attack' }],
    },
  ],

  // 炎×サポート（スピリット、天使、マーメイド）
  [CATEGORY_GROUPS.SUPPORT]: [
    {
      id: 'fire_support_1',
      name: '炎の祝福',
      description: '与える回復効果+10%、攻撃力+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.HEAL_BOOST, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 5 },
      ],
    },
    {
      id: 'fire_support_2',
      name: '聖炎の加護',
      description: '味方全体の攻撃+5%',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ALLY_BUFF, stat: 'atk', value: 5 }],
    },
    {
      id: 'fire_support_3',
      name: '浄火の癒し',
      description: '回復時、対象の攻撃↑×1付与（2T）',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HEAL, effect: { type: 'buff', buff: 'atk_up', stacks: 1, duration: 2 } }],
    },
    {
      id: 'fire_support_ult',
      name: '全体バフ',
      description: '味方全体の攻撃+15%',
      slot: 4,
      isUltimate: true,
      ultimateId: 'S1',
      effects: [{ type: PASSIVE_EFFECT_TYPES.ALLY_BUFF, stat: 'atk', value: 15 }],
    },
  ],

  // 炎×バランス（ビースト、ヒューマノイド）
  [CATEGORY_GROUPS.BALANCE]: [
    {
      id: 'fire_balance_1',
      name: '炎の魂',
      description: '攻撃力+8%、HP+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 8 },
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 5 },
      ],
    },
    {
      id: 'fire_balance_2',
      name: '闘炎',
      description: '攻撃時10%で火傷付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 10, effect: { type: 'status', status: 'burn' } }],
    },
    {
      id: 'fire_balance_3',
      name: '燃える闘志',
      description: 'HP50%以下で攻撃力+20%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.CONDITIONAL_ATK, value: 20, condition: PASSIVE_CONDITIONS.HP_BELOW, threshold: 50 }],
    },
    {
      id: 'fire_balance_ult',
      name: '追撃',
      description: '攻撃時、追加で攻撃力×30%ダメージ',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A3',
      effects: [{ type: 'follow_up_attack', multiplier: 0.3 }],
    },
  ],

  // 炎×特殊（スライム、プラント、ゴースト、魔族）
  [CATEGORY_GROUPS.SPECIAL]: [
    {
      id: 'fire_special_1',
      name: '業火の残滓',
      description: '攻撃力+5%、攻撃時10%で火傷',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 5 },
        { type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 10, effect: { type: 'status', status: 'burn' } },
      ],
    },
    {
      id: 'fire_special_2',
      name: '燃焼適応',
      description: '火傷状態でもダメージを受けない',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.STATUS_IMMUNITY, status: 'burn' }],
    },
    {
      id: 'fire_special_3',
      name: '炎の同化',
      description: '火傷状態の敵を攻撃時HP5%回復',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.LIFESTEAL, value: 5, condition: PASSIVE_CONDITIONS.TARGET_STATUS, status: 'burn' }],
    },
    {
      id: 'fire_special_ult',
      name: '魂喰い',
      description: '敵撃破時、スキルのCD1短縮',
      slot: 4,
      isUltimate: true,
      ultimateId: 'X9',
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_KILL, effect: { type: 'cd_reduce', value: 1 } }],
    },
  ],
};

// ========================================
// 水属性パッシブ（24種）
// ========================================

export const WATER_PASSIVES = {
  // 水×アタッカー
  [CATEGORY_GROUPS.ATTACKER]: [
    {
      id: 'water_attacker_1',
      name: '氷結の牙',
      description: '攻撃力+10%、HP+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 5 },
      ],
    },
    {
      id: 'water_attacker_2',
      name: '冷気の一撃',
      description: '攻撃時15%で凍結付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 15, effect: { type: 'status', status: 'freeze' } }],
    },
    {
      id: 'water_attacker_3',
      name: '氷の猛攻',
      description: '凍結状態の敵へのダメージ+25%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.STATUS_DAMAGE, status: 'freeze', value: 25 }],
    },
    {
      id: 'water_attacker_ult',
      name: '氷砕き',
      description: '凍結状態の敵に確定クリティカル+ダメージ+30%',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A8',
      effects: [
        { type: 'guaranteed_crit', condition: PASSIVE_CONDITIONS.TARGET_STATUS, status: 'freeze' },
        { type: PASSIVE_EFFECT_TYPES.STATUS_DAMAGE, status: 'freeze', value: 30 },
      ],
    },
  ],

  // 水×タンク
  [CATEGORY_GROUPS.TANK]: [
    {
      id: 'water_tank_1',
      name: '氷壁の守り',
      description: '被ダメージ-10%、HP+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 5 },
      ],
    },
    {
      id: 'water_tank_2',
      name: '凍てつく鎧',
      description: '被弾時15%で攻撃者を凍結',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HIT, chance: 15, effect: { type: 'status', status: 'freeze' } }],
    },
    {
      id: 'water_tank_3',
      name: '不動の氷山',
      description: 'HP50%以下で被ダメージ-15%追加',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.CONDITIONAL_DEF, value: 15, condition: PASSIVE_CONDITIONS.HP_BELOW, threshold: 50 }],
    },
    {
      id: 'water_tank_ult',
      name: 'ダメージ上限',
      description: '1回の被ダメージ上限を最大HPの30%に',
      slot: 4,
      isUltimate: true,
      ultimateId: 'D3',
      effects: [{ type: 'damage_cap', value: 30 }],
    },
  ],

  // 水×スピード
  [CATEGORY_GROUPS.SPEED]: [
    {
      id: 'water_speed_1',
      name: '水流の舞',
      description: '速度+15、回避+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 15 },
        { type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 5 },
      ],
    },
    {
      id: 'water_speed_2',
      name: '氷霧',
      description: '攻撃時10%で速度↓×1付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 10, effect: { type: 'debuff', debuff: 'spd_down', stacks: 1 } }],
    },
    {
      id: 'water_speed_3',
      name: '流水回避',
      description: '被弾時20%で回避',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 20 }],
    },
    {
      id: 'water_speed_ult',
      name: '霧化',
      description: 'HP30%以下で被弾時50%回避',
      slot: 4,
      isUltimate: true,
      ultimateId: 'D9',
      effects: [{ type: PASSIVE_EFFECT_TYPES.CONDITIONAL_DEF, value: 50, condition: PASSIVE_CONDITIONS.HP_BELOW, threshold: 30, defType: 'evasion' }],
    },
  ],

  // 水×サポート
  [CATEGORY_GROUPS.SUPPORT]: [
    {
      id: 'water_support_1',
      name: '癒しの水',
      description: '与える回復効果+20%',
      slot: 1,
      effects: [{ type: PASSIVE_EFFECT_TYPES.HEAL_BOOST, value: 20 }],
    },
    {
      id: 'water_support_2',
      name: '清浄の波',
      description: '回復時、対象の状態異常1つ解除',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HEAL, effect: { type: 'cleanse', count: 1 } }],
    },
    {
      id: 'water_support_3',
      name: '生命の泉',
      description: '味方全体のHP+8%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ALLY_BUFF, stat: 'hp', value: 8 }],
    },
    {
      id: 'water_support_ult',
      name: '生命共有',
      description: 'ターン終了時、味方全体をHP5%回復',
      slot: 4,
      isUltimate: true,
      ultimateId: 'H6',
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_TURN_END, effect: { type: 'heal_all', value: 5 } }],
    },
  ],

  // 水×バランス
  [CATEGORY_GROUPS.BALANCE]: [
    {
      id: 'water_balance_1',
      name: '水の恵み',
      description: 'HP+10%、被ダメージ-5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 5 },
      ],
    },
    {
      id: 'water_balance_2',
      name: '流水の構え',
      description: '被弾時10%で凍結付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HIT, chance: 10, effect: { type: 'status', status: 'freeze' } }],
    },
    {
      id: 'water_balance_3',
      name: '生命の波動',
      description: 'ターン終了時HP3%回復',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.REGEN, value: 3 }],
    },
    {
      id: 'water_balance_ult',
      name: '超再生',
      description: 'ターン終了時HP10%回復',
      slot: 4,
      isUltimate: true,
      ultimateId: 'H3',
      effects: [{ type: PASSIVE_EFFECT_TYPES.REGEN, value: 10 }],
    },
  ],

  // 水×特殊
  [CATEGORY_GROUPS.SPECIAL]: [
    {
      id: 'water_special_1',
      name: '水の変容',
      description: 'HP+8%、被弾時10%で凍結付与',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 8 },
        { type: PASSIVE_EFFECT_TYPES.ON_HIT, chance: 10, effect: { type: 'status', status: 'freeze' } },
      ],
    },
    {
      id: 'water_special_2',
      name: '流動体',
      description: '物理攻撃の被ダメージ-15%',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 15, damageType: 'physical' }],
    },
    {
      id: 'water_special_3',
      name: '融合再生',
      description: 'HP30%以下でターン終了時HP8%回復',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.REGEN, value: 8, condition: PASSIVE_CONDITIONS.HP_BELOW, threshold: 30 }],
    },
    {
      id: 'water_special_ult',
      name: '分裂',
      description: '戦闘不能時、HP30%の分身を1体生成',
      slot: 4,
      isUltimate: true,
      ultimateId: 'D7',
      effects: [{ type: 'split', hpPercent: 30 }],
    },
  ],
};

// ========================================
// 光属性パッシブ（24種）
// ========================================

export const LIGHT_PASSIVES = {
  // 光×アタッカー
  [CATEGORY_GROUPS.ATTACKER]: [
    {
      id: 'light_attacker_1',
      name: '聖光の力',
      description: '攻撃力+10%、闇属性へのダメージ+10%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.ATTRIBUTE_DAMAGE, attribute: '闇', value: 10 },
      ],
    },
    {
      id: 'light_attacker_2',
      name: '裁きの光',
      description: '攻撃時15%で麻痺付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 15, effect: { type: 'status', status: 'paralysis' } }],
    },
    {
      id: 'light_attacker_3',
      name: '光輝の一撃',
      description: 'クリティカル時ダメージ+20%',
      slot: 3,
      effects: [{ type: 'crit_damage', value: 20 }],
    },
    {
      id: 'light_attacker_ult',
      name: '確定クリティカル',
      description: 'HP30%以下の敵に確定クリ',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A2',
      effects: [{ type: 'guaranteed_crit', condition: PASSIVE_CONDITIONS.TARGET_HP_BELOW, threshold: 30 }],
    },
  ],

  // 光×タンク
  [CATEGORY_GROUPS.TANK]: [
    {
      id: 'light_tank_1',
      name: '聖なる守護',
      description: '被ダメージ-8%、闇属性から-15%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 8 },
        { type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 15, fromAttribute: '闇' },
      ],
    },
    {
      id: 'light_tank_2',
      name: '光の盾',
      description: '戦闘開始時、シールド（最大HP15%）',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_BATTLE_START, effect: { type: 'shield', value: 15 } }],
    },
    {
      id: 'light_tank_3',
      name: '守護者の誓い',
      description: 'HP低い味方への攻撃を20%でかばう',
      slot: 3,
      effects: [{ type: 'cover', chance: 20, condition: 'lowest_hp' }],
    },
    {
      id: 'light_tank_ult',
      name: 'かばう',
      description: 'HP低い味方への攻撃を自動でかばう',
      slot: 4,
      isUltimate: true,
      ultimateId: 'D5',
      effects: [{ type: 'cover', chance: 100, condition: 'lowest_hp' }],
    },
  ],

  // 光×スピード
  [CATEGORY_GROUPS.SPEED]: [
    {
      id: 'light_speed_1',
      name: '光の翼',
      description: '速度+15、回避+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 15 },
        { type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 5 },
      ],
    },
    {
      id: 'light_speed_2',
      name: '閃光',
      description: '攻撃時10%で麻痺付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 10, effect: { type: 'status', status: 'paralysis' } }],
    },
    {
      id: 'light_speed_3',
      name: '聖なる加速',
      description: '戦闘開始時、速度↑×2付与（3T）',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_BATTLE_START, effect: { type: 'buff', buff: 'spd_up', stacks: 2, duration: 3 } }],
    },
    {
      id: 'light_speed_ult',
      name: '先制',
      description: '必ず最初に行動',
      slot: 4,
      isUltimate: true,
      ultimateId: 'X3',
      effects: [{ type: 'preemptive' }],
    },
  ],

  // 光×サポート
  [CATEGORY_GROUPS.SUPPORT]: [
    {
      id: 'light_support_1',
      name: '聖なる癒し',
      description: '与える回復効果+20%',
      slot: 1,
      effects: [{ type: PASSIVE_EFFECT_TYPES.HEAL_BOOST, value: 20 }],
    },
    {
      id: 'light_support_2',
      name: '浄化の光',
      description: '回復時、対象のデバフを1つ解除',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HEAL, effect: { type: 'cleanse_debuff', count: 1 } }],
    },
    {
      id: 'light_support_3',
      name: '祝福の輝き',
      description: '味方全体の受ける回復+15%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ALLY_BUFF, stat: 'heal_received', value: 15 }],
    },
    {
      id: 'light_support_ult',
      name: '復活',
      description: '戦闘中1回、HP1%で復活',
      slot: 4,
      isUltimate: true,
      ultimateId: 'H1',
      effects: [{ type: 'revive', hpPercent: 1, uses: 1 }],
    },
  ],

  // 光×バランス
  [CATEGORY_GROUPS.BALANCE]: [
    {
      id: 'light_balance_1',
      name: '光の加護',
      description: '攻撃力+5%、HP+5%、被ダメージ-5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 5 },
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 5 },
        { type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 5 },
      ],
    },
    {
      id: 'light_balance_2',
      name: '聖光の恵み',
      description: 'ターン終了時HP2%回復',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.REGEN, value: 2 }],
    },
    {
      id: 'light_balance_3',
      name: '光輝の守り',
      description: '闇属性からの被ダメージ-25%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 25, fromAttribute: '闇' }],
    },
    {
      id: 'light_balance_ult',
      name: 'オーラ',
      description: '味方全体の被ダメージ-10%',
      slot: 4,
      isUltimate: true,
      ultimateId: 'S2',
      effects: [{ type: PASSIVE_EFFECT_TYPES.ALLY_BUFF, stat: 'damage_reduce', value: 10 }],
    },
  ],

  // 光×特殊
  [CATEGORY_GROUPS.SPECIAL]: [
    {
      id: 'light_special_1',
      name: '聖なる異端',
      description: '攻撃力+8%、状態異常耐性+10%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 8 },
        { type: 'status_resistance', value: 10 },
      ],
    },
    {
      id: 'light_special_2',
      name: '浄化の存在',
      description: '戦闘開始時、自身の状態異常全解除',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_BATTLE_START, effect: { type: 'cleanse_self', all: true } }],
    },
    {
      id: 'light_special_3',
      name: '光の同化',
      description: '闇属性の敵撃破時HP20%回復',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_KILL, condition: { targetAttribute: '闇' }, effect: { type: 'heal_self', value: 20 } }],
    },
    {
      id: 'light_special_ult',
      name: '状態異常無効',
      description: '状態異常を完全無効',
      slot: 4,
      isUltimate: true,
      ultimateId: 'X2',
      effects: [{ type: PASSIVE_EFFECT_TYPES.STATUS_IMMUNITY, all: true }],
    },
  ],
};

// ========================================
// 闇属性パッシブ（24種）
// ========================================

export const DARK_PASSIVES = {
  // 闇×アタッカー
  [CATEGORY_GROUPS.ATTACKER]: [
    {
      id: 'dark_attacker_1',
      name: '闇の捕食者',
      description: '攻撃力+10%、与ダメの5%吸収',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.LIFESTEAL, value: 5 },
      ],
    },
    {
      id: 'dark_attacker_2',
      name: '死の宣告',
      description: '攻撃時10%で呪い付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 10, effect: { type: 'status', status: 'curse' } }],
    },
    {
      id: 'dark_attacker_3',
      name: '絶望の一撃',
      description: 'HP50%以下の敵へのダメージ+20%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.CONDITIONAL_DMG, value: 20, condition: PASSIVE_CONDITIONS.TARGET_HP_BELOW, threshold: 50 }],
    },
    {
      id: 'dark_attacker_ult',
      name: '処刑',
      description: 'HP20%以下の敵に即死判定（30%）',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A5',
      effects: [{ type: 'execute', threshold: 20, chance: 30 }],
    },
  ],

  // 闇×タンク
  [CATEGORY_GROUPS.TANK]: [
    {
      id: 'dark_tank_1',
      name: '闇の鎧',
      description: '被ダメージ-8%、与ダメの8%吸収',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 8 },
        { type: PASSIVE_EFFECT_TYPES.LIFESTEAL, value: 8 },
      ],
    },
    {
      id: 'dark_tank_2',
      name: '暗黒の呪縛',
      description: '被弾時15%で攻撃者に呪い付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HIT, chance: 15, effect: { type: 'status', status: 'curse' } }],
    },
    {
      id: 'dark_tank_3',
      name: '闇の再生',
      description: '被弾時HP3%回復',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HIT, effect: { type: 'heal_self', value: 3 } }],
    },
    {
      id: 'dark_tank_ult',
      name: '根性',
      description: 'HP1以上なら致死ダメージを1回耐える',
      slot: 4,
      isUltimate: true,
      ultimateId: 'D4',
      effects: [{ type: 'guts', uses: 1 }],
    },
  ],

  // 闇×スピード
  [CATEGORY_GROUPS.SPEED]: [
    {
      id: 'dark_speed_1',
      name: '影の疾走',
      description: '速度+15、攻撃力+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 15 },
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 5 },
      ],
    },
    {
      id: 'dark_speed_2',
      name: '暗殺者の本能',
      description: 'クリティカル率+10%',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.CRIT_RATE, value: 10 }],
    },
    {
      id: 'dark_speed_3',
      name: '闇討ち',
      description: '先制攻撃時ダメージ+25%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.CONDITIONAL_DMG, value: 25, condition: PASSIVE_CONDITIONS.FIRST_ATTACK }],
    },
    {
      id: 'dark_speed_ult',
      name: '2回行動',
      description: '20%で同じターンにもう1回行動',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A1',
      effects: [{ type: 'extra_turn', chance: 20 }],
    },
  ],

  // 闇×サポート
  [CATEGORY_GROUPS.SUPPORT]: [
    {
      id: 'dark_support_1',
      name: '闇の祝福',
      description: '与える回復効果+10%、与ダメの10%吸収',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.HEAL_BOOST, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.LIFESTEAL, value: 10 },
      ],
    },
    {
      id: 'dark_support_2',
      name: '呪詛の霧',
      description: '敵全体の攻撃-5%（常時）',
      slot: 2,
      effects: [{ type: 'enemy_debuff_aura', stat: 'atk', value: -5 }],
    },
    {
      id: 'dark_support_3',
      name: '生贄の儀式',
      description: '味方回復時、自身のHP5%消費で回復量+30%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HEAL, effect: { type: 'boost_heal', value: 30, selfDamage: 5 } }],
    },
    {
      id: 'dark_support_ult',
      name: '継承',
      description: '自分が倒れた時、味方1体にバフ全移譲',
      slot: 4,
      isUltimate: true,
      ultimateId: 'S4',
      effects: [{ type: 'inherit_buffs' }],
    },
  ],

  // 闇×バランス
  [CATEGORY_GROUPS.BALANCE]: [
    {
      id: 'dark_balance_1',
      name: '闇の本能',
      description: '攻撃力+8%、与ダメの5%吸収',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 8 },
        { type: PASSIVE_EFFECT_TYPES.LIFESTEAL, value: 5 },
      ],
    },
    {
      id: 'dark_balance_2',
      name: '弱者狩り',
      description: 'HP50%以下の敵へのダメージ+15%',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.CONDITIONAL_DMG, value: 15, condition: PASSIVE_CONDITIONS.TARGET_HP_BELOW, threshold: 50 }],
    },
    {
      id: 'dark_balance_3',
      name: '闇の適応',
      description: '光属性からの被ダメージ-20%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 20, fromAttribute: '光' }],
    },
    {
      id: 'dark_balance_ult',
      name: '吸収',
      description: '与ダメージの20%をHP回復',
      slot: 4,
      isUltimate: true,
      ultimateId: 'H2',
      effects: [{ type: PASSIVE_EFFECT_TYPES.LIFESTEAL, value: 20 }],
    },
  ],

  // 闇×特殊
  [CATEGORY_GROUPS.SPECIAL]: [
    {
      id: 'dark_special_1',
      name: '怨念の塊',
      description: '攻撃力+5%、被弾時10%で呪い付与',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 5 },
        { type: PASSIVE_EFFECT_TYPES.ON_HIT, chance: 10, effect: { type: 'status', status: 'curse' } },
      ],
    },
    {
      id: 'dark_special_2',
      name: '幽体',
      description: '被弾時15%でダメージ無効化',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 15 }],
    },
    {
      id: 'dark_special_3',
      name: '魂の収集',
      description: '敵撃破時、攻撃力+5%永続（最大15%）',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_KILL, effect: { type: 'permanent_atk', value: 5, max: 15 } }],
    },
    {
      id: 'dark_special_ult',
      name: '闇の捕食',
      description: '撃破時、敵の攻撃力5%を永続獲得（最大25%）',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A10',
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_KILL, effect: { type: 'steal_atk', value: 5, max: 25 } }],
    },
  ],
};

// ========================================
// 未来属性パッシブ（24種）
// ========================================

export const FUTURE_PASSIVES = {
  // 未来×アタッカー
  [CATEGORY_GROUPS.ATTACKER]: [
    {
      id: 'future_attacker_1',
      name: '時空の力',
      description: '攻撃力+10%、速度+5',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 5 },
      ],
    },
    {
      id: 'future_attacker_2',
      name: '時の刻印',
      description: '攻撃時15%で時止付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 15, effect: { type: 'status', status: 'time_stop' } }],
    },
    {
      id: 'future_attacker_3',
      name: '時空崩壊',
      description: '時止状態の敵へのダメージ+30%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.STATUS_DAMAGE, status: 'time_stop', value: 30 }],
    },
    {
      id: 'future_attacker_ult',
      name: '時の支配者',
      description: '時止状態の敵に2回攻撃',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A11',
      effects: [{ type: 'double_attack', condition: PASSIVE_CONDITIONS.TARGET_STATUS, status: 'time_stop' }],
    },
  ],

  // 未来×タンク
  [CATEGORY_GROUPS.TANK]: [
    {
      id: 'future_tank_1',
      name: '時空の鎧',
      description: '被ダメージ-8%、速度+10',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 8 },
        { type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 10 },
      ],
    },
    {
      id: 'future_tank_2',
      name: '時の歪み',
      description: '被弾時15%で攻撃者に時止付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HIT, chance: 15, effect: { type: 'status', status: 'time_stop' } }],
    },
    {
      id: 'future_tank_3',
      name: '予知防御',
      description: '被弾時20%でダメージ半減',
      slot: 3,
      effects: [{ type: 'damage_halve', chance: 20 }],
    },
    {
      id: 'future_tank_ult',
      name: '無敵',
      description: '戦闘開始時1ターン無敵',
      slot: 4,
      isUltimate: true,
      ultimateId: 'D1',
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_BATTLE_START, effect: { type: 'invincible', duration: 1 } }],
    },
  ],

  // 未来×スピード
  [CATEGORY_GROUPS.SPEED]: [
    {
      id: 'future_speed_1',
      name: '時の加速',
      description: '速度+25',
      slot: 1,
      effects: [{ type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 25 }],
    },
    {
      id: 'future_speed_2',
      name: '瞬間移動',
      description: '被弾時20%で回避',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 20 }],
    },
    {
      id: 'future_speed_3',
      name: '時空跳躍',
      description: '行動後20%で速度↑×1獲得',
      slot: 3,
      effects: [{ type: 'after_action', chance: 20, effect: { type: 'buff', buff: 'spd_up', stacks: 1 } }],
    },
    {
      id: 'future_speed_ult',
      name: '疾風怒濤',
      description: '速度が敵より30以上高い時、ダメージ+25%',
      slot: 4,
      isUltimate: true,
      ultimateId: 'X10',
      effects: [{ type: 'speed_damage', threshold: 30, value: 25 }],
    },
  ],

  // 未来×サポート
  [CATEGORY_GROUPS.SUPPORT]: [
    {
      id: 'future_support_1',
      name: '時の恵み',
      description: '与える回復効果+15%、速度+10',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.HEAL_BOOST, value: 15 },
        { type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 10 },
      ],
    },
    {
      id: 'future_support_2',
      name: '時間遡行',
      description: '回復スキル使用時、対象のデバフターン-1',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HEAL, effect: { type: 'reduce_debuff_duration', value: 1 } }],
    },
    {
      id: 'future_support_3',
      name: '未来への希望',
      description: '味方全体の速度+10',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ALLY_BUFF, stat: 'spd', value: 10 }],
    },
    {
      id: 'future_support_ult',
      name: '死の淵からの帰還',
      description: '蘇生された時、HP50%で復帰',
      slot: 4,
      isUltimate: true,
      ultimateId: 'H7',
      effects: [{ type: 'revive_bonus', hpPercent: 50 }],
    },
  ],

  // 未来×バランス
  [CATEGORY_GROUPS.BALANCE]: [
    {
      id: 'future_balance_1',
      name: '時の流れ',
      description: '速度+15、攻撃力+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 15 },
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 5 },
      ],
    },
    {
      id: 'future_balance_2',
      name: '先見の明',
      description: '戦闘開始時、回避↑×1付与（2T）',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_BATTLE_START, effect: { type: 'buff', buff: 'evasion_up', stacks: 1, duration: 2 } }],
    },
    {
      id: 'future_balance_3',
      name: '時空の恩恵',
      description: '状態異常の持続ターン-1',
      slot: 3,
      effects: [{ type: 'status_duration_reduce', value: 1 }],
    },
    {
      id: 'future_balance_ult',
      name: '不屈',
      description: '状態異常のターン数-1',
      slot: 4,
      isUltimate: true,
      ultimateId: 'X5',
      effects: [{ type: 'status_duration_reduce', value: 1 }],
    },
  ],

  // 未来×特殊
  [CATEGORY_GROUPS.SPECIAL]: [
    {
      id: 'future_special_1',
      name: '時空の異端',
      description: '速度+10、攻撃時5%で時止付与',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 5, effect: { type: 'status', status: 'time_stop' } },
      ],
    },
    {
      id: 'future_special_2',
      name: '時の停滞',
      description: '自身へのデバフ持続ターン-1',
      slot: 2,
      effects: [{ type: 'debuff_duration_reduce', value: 1, target: 'self' }],
    },
    {
      id: 'future_special_3',
      name: '存在の揺らぎ',
      description: '被弾時15%で完全回避',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 15 }],
    },
    {
      id: 'future_special_ult',
      name: '幽体化',
      description: '被弾時20%で完全無効化',
      slot: 4,
      isUltimate: true,
      ultimateId: 'X11',
      effects: [{ type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 20, nullify: true }],
    },
  ],
};

// ========================================
// 原始属性パッシブ（24種）
// ========================================

export const PRIMITIVE_PASSIVES = {
  // 原始×アタッカー
  [CATEGORY_GROUPS.ATTACKER]: [
    {
      id: 'primitive_attacker_1',
      name: '原始の力',
      description: '攻撃力+8%、HP+8%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 8 },
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 8 },
      ],
    },
    {
      id: 'primitive_attacker_2',
      name: '猛毒の牙',
      description: '攻撃時20%で毒×1付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 20, effect: { type: 'status', status: 'poison', stacks: 1 } }],
    },
    {
      id: 'primitive_attacker_3',
      name: '野生の本能',
      description: 'HP50%以下で攻撃力+25%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.CONDITIONAL_ATK, value: 25, condition: PASSIVE_CONDITIONS.HP_BELOW, threshold: 50 }],
    },
    {
      id: 'primitive_attacker_ult',
      name: '猛毒強化',
      description: '自身が与える毒ダメージ2倍',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A9',
      effects: [{ type: 'poison_damage_boost', multiplier: 2 }],
    },
  ],

  // 原始×タンク
  [CATEGORY_GROUPS.TANK]: [
    {
      id: 'primitive_tank_1',
      name: '原始の体躯',
      description: 'HP+15%、被ダメージ-5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 15 },
        { type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 5 },
      ],
    },
    {
      id: 'primitive_tank_2',
      name: '毒の鎧',
      description: '被弾時20%で攻撃者に毒付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HIT, chance: 20, effect: { type: 'status', status: 'poison' } }],
    },
    {
      id: 'primitive_tank_3',
      name: '大地の恵み',
      description: 'ターン終了時HP5%回復',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.REGEN, value: 5 }],
    },
    {
      id: 'primitive_tank_ult',
      name: '瀕死回復',
      description: 'HP20%以下になった時、1回だけHP50%回復',
      slot: 4,
      isUltimate: true,
      ultimateId: 'H5',
      effects: [{ type: 'emergency_heal', threshold: 20, healPercent: 50, uses: 1 }],
    },
  ],

  // 原始×スピード
  [CATEGORY_GROUPS.SPEED]: [
    {
      id: 'primitive_speed_1',
      name: '野生の俊敏',
      description: '速度+10、攻撃時10%で毒付与',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 10, effect: { type: 'status', status: 'poison' } },
      ],
    },
    {
      id: 'primitive_speed_2',
      name: '毒針',
      description: '攻撃時15%で毒×1付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 15, effect: { type: 'status', status: 'poison', stacks: 1 } }],
    },
    {
      id: 'primitive_speed_3',
      name: '致死の一撃',
      description: '毒状態の敵への攻撃時クリティカル率+20%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.CRIT_RATE, value: 20, condition: PASSIVE_CONDITIONS.TARGET_STATUS, status: 'poison' }],
    },
    {
      id: 'primitive_speed_ult',
      name: '連撃',
      description: '通常攻撃が2回になる',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A6',
      effects: [{ type: 'double_attack' }],
    },
  ],

  // 原始×サポート
  [CATEGORY_GROUPS.SUPPORT]: [
    {
      id: 'primitive_support_1',
      name: '大地の癒し',
      description: '与える回復効果+15%、HP+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.HEAL_BOOST, value: 15 },
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 5 },
      ],
    },
    {
      id: 'primitive_support_2',
      name: '自然の恵み',
      description: '回復時、対象に再生×1付与（2T）',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HEAL, effect: { type: 'buff', buff: 'regen', stacks: 1, duration: 2 } }],
    },
    {
      id: 'primitive_support_3',
      name: '生命の循環',
      description: '味方全体のHP+10%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ALLY_BUFF, stat: 'hp', value: 10 }],
    },
    {
      id: 'primitive_support_ult',
      name: '回復強化',
      description: '受ける回復効果+50%',
      slot: 4,
      isUltimate: true,
      ultimateId: 'H4',
      effects: [{ type: PASSIVE_EFFECT_TYPES.HEAL_RECEIVED, value: 50 }],
    },
  ],

  // 原始×バランス
  [CATEGORY_GROUPS.BALANCE]: [
    {
      id: 'primitive_balance_1',
      name: '原始の生命',
      description: 'HP+12%、攻撃力+3%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 12 },
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 3 },
      ],
    },
    {
      id: 'primitive_balance_2',
      name: '野生の再生',
      description: 'ターン終了時HP3%回復',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.REGEN, value: 3 }],
    },
    {
      id: 'primitive_balance_3',
      name: '毒耐性',
      description: '毒状態無効、毒攻撃時与ダメ+15%',
      slot: 3,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.STATUS_IMMUNITY, status: 'poison' },
        { type: PASSIVE_EFFECT_TYPES.STATUS_DAMAGE, status: 'poison', value: 15, onInflict: true },
      ],
    },
    {
      id: 'primitive_balance_ult',
      name: '適応',
      description: '同じ敵からの連続攻撃ダメージ-20%ずつ',
      slot: 4,
      isUltimate: true,
      ultimateId: 'X6',
      effects: [{ type: 'adaptation', reduction: 20, condition: PASSIVE_CONDITIONS.SAME_ENEMY_HIT }],
    },
  ],

  // 原始×特殊
  [CATEGORY_GROUPS.SPECIAL]: [
    {
      id: 'primitive_special_1',
      name: '毒の体',
      description: 'HP+5%、被弾時15%で毒付与',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 5 },
        { type: PASSIVE_EFFECT_TYPES.ON_HIT, chance: 15, effect: { type: 'status', status: 'poison' } },
      ],
    },
    {
      id: 'primitive_special_2',
      name: '毒の同化',
      description: '毒状態でダメージを受けず、代わりにHP回復',
      slot: 2,
      effects: [{ type: 'poison_absorb' }],
    },
    {
      id: 'primitive_special_3',
      name: '増殖',
      description: 'HP50%以下で毎ターン攻撃力+5%（最大20%）',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.CONDITIONAL_ATK, value: 5, perTurn: true, max: 20, condition: PASSIVE_CONDITIONS.HP_BELOW, threshold: 50 }],
    },
    {
      id: 'primitive_special_ult',
      name: '分裂',
      description: '戦闘不能時、HP30%の分身を1体生成',
      slot: 4,
      isUltimate: true,
      ultimateId: 'D7',
      effects: [{ type: 'split', hpPercent: 30 }],
    },
  ],
};

// ========================================
// 無属性パッシブ（24種）
// ========================================

export const NEUTRAL_PASSIVES = {
  // 無×アタッカー
  [CATEGORY_GROUPS.ATTACKER]: [
    {
      id: 'neutral_attacker_1',
      name: '無の力',
      description: '攻撃力+10%、虚脱耐性',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 10 },
        { type: PASSIVE_EFFECT_TYPES.STATUS_IMMUNITY, status: 'exhaust' },
      ],
    },
    {
      id: 'neutral_attacker_2',
      name: '空虚の一撃',
      description: '攻撃時15%で虚脱付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_ATTACK, chance: 15, effect: { type: 'status', status: 'exhaust' } }],
    },
    {
      id: 'neutral_attacker_3',
      name: '万象の攻撃',
      description: '属性相性無視（等倍で計算）',
      slot: 3,
      effects: [{ type: 'ignore_attribute' }],
    },
    {
      id: 'neutral_attacker_ult',
      name: '貫通',
      description: '防御を50%無視',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A4',
      effects: [{ type: 'armor_pierce', value: 50 }],
    },
  ],

  // 無×タンク
  [CATEGORY_GROUPS.TANK]: [
    {
      id: 'neutral_tank_1',
      name: '無の守護',
      description: '被ダメージ-10%、全属性耐性+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 10 },
        { type: 'all_attribute_resist', value: 5 },
      ],
    },
    {
      id: 'neutral_tank_2',
      name: '虚無の鎧',
      description: '被弾時10%で攻撃者に虚脱付与',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HIT, chance: 10, effect: { type: 'status', status: 'exhaust' } }],
    },
    {
      id: 'neutral_tank_3',
      name: '万象の防御',
      description: '全属性からの被ダメージ-10%',
      slot: 3,
      effects: [{ type: 'all_attribute_resist', value: 10 }],
    },
    {
      id: 'neutral_tank_ult',
      name: 'バリア',
      description: '戦闘開始時、最大HP30%分のシールド',
      slot: 4,
      isUltimate: true,
      ultimateId: 'D6',
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_BATTLE_START, effect: { type: 'shield', value: 30 } }],
    },
  ],

  // 無×スピード
  [CATEGORY_GROUPS.SPEED]: [
    {
      id: 'neutral_speed_1',
      name: '虚空の舞',
      description: '速度+15、回避+5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.SPD_FLAT, value: 15 },
        { type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 5 },
      ],
    },
    {
      id: 'neutral_speed_2',
      name: '空虚の残像',
      description: '被弾時15%で回避、回避時攻撃↑×1',
      slot: 2,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 15 },
        { type: 'on_evade', effect: { type: 'buff', buff: 'atk_up', stacks: 1 } },
      ],
    },
    {
      id: 'neutral_speed_3',
      name: '次元跳躍',
      description: '行動後15%で追加行動',
      slot: 3,
      effects: [{ type: 'extra_turn', chance: 15 }],
    },
    {
      id: 'neutral_speed_ult',
      name: '2回行動',
      description: '20%で同じターンにもう1回行動',
      slot: 4,
      isUltimate: true,
      ultimateId: 'A1',
      effects: [{ type: 'extra_turn', chance: 20 }],
    },
  ],

  // 無×サポート
  [CATEGORY_GROUPS.SUPPORT]: [
    {
      id: 'neutral_support_1',
      name: '無の癒し',
      description: '与える回復効果+15%、状態異常耐性+10%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.HEAL_BOOST, value: 15 },
        { type: 'status_resistance', value: 10 },
      ],
    },
    {
      id: 'neutral_support_2',
      name: '平穏の祈り',
      description: '回復時、対象のバフターン+1',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_HEAL, effect: { type: 'extend_buff', value: 1 } }],
    },
    {
      id: 'neutral_support_3',
      name: '調和の力',
      description: '味方全体の状態異常耐性+15%',
      slot: 3,
      effects: [{ type: PASSIVE_EFFECT_TYPES.ALLY_BUFF, stat: 'status_resistance', value: 15 }],
    },
    {
      id: 'neutral_support_ult',
      name: '鼓舞',
      description: '味方が倒れた時、生存者の攻撃+20%',
      slot: 4,
      isUltimate: true,
      ultimateId: 'S3',
      effects: [{ type: 'on_ally_death', effect: { type: 'buff_survivors', stat: 'atk', value: 20 } }],
    },
  ],

  // 無×バランス
  [CATEGORY_GROUPS.BALANCE]: [
    {
      id: 'neutral_balance_1',
      name: '無の境地',
      description: '攻撃力+5%、HP+5%、被ダメージ-5%',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.ATK_PERCENT, value: 5 },
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 5 },
        { type: PASSIVE_EFFECT_TYPES.DAMAGE_REDUCE, value: 5 },
      ],
    },
    {
      id: 'neutral_balance_2',
      name: '適応力',
      description: '属性不利軽減（×0.67→×0.8）',
      slot: 2,
      effects: [{ type: 'attribute_disadvantage_reduce', value: 0.13 }],
    },
    {
      id: 'neutral_balance_3',
      name: '万能の才',
      description: '全ステータス+5%',
      slot: 3,
      effects: [{ type: 'all_stats', value: 5 }],
    },
    {
      id: 'neutral_balance_ult',
      name: '弱点無効',
      description: '属性相性の不利を無効化',
      slot: 4,
      isUltimate: true,
      ultimateId: 'X1',
      effects: [{ type: 'ignore_attribute_weakness' }],
    },
  ],

  // 無×特殊
  [CATEGORY_GROUPS.SPECIAL]: [
    {
      id: 'neutral_special_1',
      name: '虚無の存在',
      description: 'HP+8%、被弾時10%で虚脱付与',
      slot: 1,
      effects: [
        { type: PASSIVE_EFFECT_TYPES.HP_PERCENT, value: 8 },
        { type: PASSIVE_EFFECT_TYPES.ON_HIT, chance: 10, effect: { type: 'status', status: 'exhaust' } },
      ],
    },
    {
      id: 'neutral_special_2',
      name: '形なき者',
      description: '被弾時15%でダメージ無効化',
      slot: 2,
      effects: [{ type: PASSIVE_EFFECT_TYPES.EVASION_RATE, value: 15, nullify: true }],
    },
    {
      id: 'neutral_special_3',
      name: '虚無への回帰',
      description: '戦闘不能時、50%で即座にHP10%復活',
      slot: 3,
      effects: [{ type: 'instant_revive', chance: 50, hpPercent: 10 }],
    },
    {
      id: 'neutral_special_ult',
      name: 'コピー',
      description: '戦闘開始時、ランダムな敵のパッシブ1つをコピー',
      slot: 4,
      isUltimate: true,
      ultimateId: 'X7',
      effects: [{ type: PASSIVE_EFFECT_TYPES.ON_BATTLE_START, effect: { type: 'copy_passive', target: 'random_enemy' } }],
    },
  ],
};

// ========================================
// 属性パッシブマップ
// ========================================

export const ATTRIBUTE_PASSIVES = {
  '炎': FIRE_PASSIVES,
  '水': WATER_PASSIVES,
  '光': LIGHT_PASSIVES,
  '闇': DARK_PASSIVES,
  '未来': FUTURE_PASSIVES,
  '原始': PRIMITIVE_PASSIVES,
  'なし': NEUTRAL_PASSIVES,
};

/**
 * 属性とカテゴリグループからパッシブセットを取得
 * @param {string} attribute - 属性
 * @param {string} categoryGroup - カテゴリグループ
 * @returns {Object[]} パッシブ配列（4つ）
 */
export const getAttributePassives = (attribute, categoryGroup) => {
  const attrPassives = ATTRIBUTE_PASSIVES[attribute];
  if (!attrPassives) {
    // 未知の属性は無属性として扱う
    return NEUTRAL_PASSIVES[categoryGroup] || NEUTRAL_PASSIVES[CATEGORY_GROUPS.BALANCE];
  }

  return attrPassives[categoryGroup] || attrPassives[CATEGORY_GROUPS.BALANCE];
};

export default {
  PASSIVE_EFFECT_TYPES,
  PASSIVE_CONDITIONS,
  ATTRIBUTE_PASSIVES,
  getAttributePassives,
};
